import { get, post, put, del } from 'utils/api';

export const getQualificationChecklist = async (
  organizationId,
  propertyId,
  householdId,
  applicationId,
  applicantId,
  options = {},
) => {
  let url = `/${organizationId}/${propertyId}/application/${applicationId}/applicant/${applicantId}/affordableQualificationChecklist`;
  // REACT_APP_HUD_ACTIVE
  if (process.env.REACT_APP_HUD_ACTIVE === 'true') {
    url = `/${organizationId}/${propertyId}/households/${householdId}/applicants/${applicantId}/affordable-qualification-checklist`;
  }
  const response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const putQualificationChecklist = async (
  organizationId,
  propertyId,
  householdId,
  applicationId,
  applicantId,
  data,
  options = {},
) => {
  let url = `/portal/${organizationId}/${propertyId}/application/${applicationId}/applicant/${applicantId}/affordableQualificationChecklist`;
  // REACT_APP_HUD_ACTIVE
  if (process.env.REACT_APP_HUD_ACTIVE === 'true') {
    url = `/portal/${organizationId}/${propertyId}/households/${householdId}/applicants/${applicantId}/affordable-qualification-checklist`;
  }
  const response = await put(url, data, options);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const getPrequalifyOptions = async (
  organizationId,
  propertyId,
  options = {},
) => {
  const url = `/${organizationId}/${propertyId}/set-aside-programs/prequalify-options`;
  const response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const startRecert = async (
  organizationId,
  propertyId,
  householdId,
  propertyAffordableProgramId,
  options = {},
) => {
  const url = `/${organizationId}/${propertyId}/households/${householdId}/start-recert`;
  const response = await put(url, { propertyAffordableProgramId }, options);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const getPropertyInfo = async (
  organizationId,
  propertyId,
  options = {},
) => {
  const url = `/${organizationId}/properties/${propertyId}/include-onboarding`;
  const response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const getAffordaDetails = async (
  organizationId,
  propertyId,
  userId,
  options = {},
) => {
  const url = `/${organizationId}/${propertyId}/afforda-portal-details/portal-user/${userId}`;
  const response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  // idk why this returns an empty string instead of null
  return response === '' ? null : response; // return null if response is empty
};

export const createAffordaDetails = async (
  organizationId,
  propertyId,
  data = {},
) => {
  const url = `/${organizationId}/${propertyId}/afforda-portal-details`;
  const response = await post(url, data);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const deleteAffordaDetails = async (
  organizationId,
  propertyId,
  id,
  options,
) => {
  const url = `/${organizationId}/${propertyId}/afforda-portal-details/${id}`;
  return del(url, options);
};

export const updateAffordaDetails = async (
  organizationId,
  propertyId,
  affordaDetailsId,
  data = {},
) => {
  const url = `/${organizationId}/${propertyId}/afforda-portal-details/${affordaDetailsId}`;
  const response = await put(url, data);

  if (response.error) {
    return response.error;
  }

  return response;
};
